import { motion } from 'framer-motion';
import styled from 'styled-components';

import { ButtonIcon } from '../Sections/Profile/Buttons';

export const MOBILE_NAVIGATION_HEIGHT = 56;

export const MainNavigationMobileContainer = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    background-color: rgb(10, 8, 27, 0.9);
    // Remove Blur for scroll performance
    // backdrop-filter: blur(54px);

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: none;
    }
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    width: 100%;
`;

export const NavigationButton = styled.button`
    width: 100%;
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    border: 0;
    padding: 0;
    height: ${MOBILE_NAVIGATION_HEIGHT}px;
    cursor: pointer;
    border-top: 1px solid rgba(255, 255, 255, 0.1);

    svg {
        width: 18px;
        height: 18px;
    }

    &:after {
        position: absolute;
        content: '';
        width: 1px;
        height: 17px;
        background-color: rgba(255, 255, 255, 0.1);
        right: 0;
    }

    &:last-child:after {
        display: none;
    }
`;

export const NavigationButtonInside = styled.div`
    position: relative;
`;

///
/// Overflow menu

export const OverflowMenuWrapper = styled(motion.nav)`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    overscroll-behavior-y: contain;
    z-index: 50;
    background-color: #0b0b0c;
    padding: 32px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: none;
    }
`;

export const CloseButtonWrapper = styled.div`
    position: absolute;
    right: 25px;
    top: 25px;
`;

export const OverflowList = styled(motion.ul)`
    font-weight: 700;
    font-size: 16px;
`;

export const OverflowMenuLabel = styled.li`
    display: block;
    font-size: 12px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 20px;

    &:first-child {
        margin-top: 0;
    }
`;

export const OverflowMenuItem = styled.li`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 16px;
    color: #fff;

    a {
        padding: 8px 0;
        display: block;
    }

    // icon
    svg {
        width: 20px;
        height: 20px;
        margin-right: 5px;
    }
`;

export const OverflowMenuSpacer = styled.li`
    margin: 25px 0;
`;

export const OverflowMenuButton = styled.button<{ isDestructive?: boolean }>`
    font-size: 16px;
    color: ${(props) => (props.isDestructive ? '#FF7D7D' : 'white')};
    padding: 0;
    appearance: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    padding: 10px 0;
    font-weight: 700;
    display: block;
    width: 100%;
    text-align: left;
`;

export const OverflowMenuAdminItem = styled.li`
    display: block;
    font-size: 14px;
    color: #fff;

    a {
        padding: 4px 0;
        display: block;
    }

    &:first-child {
        margin-top: 8px;
    }

    // emoji
    span {
        margin-right: 5px;
    }
`;

export const NavigationButtonIndicator = styled.div`
    position: absolute;
    top: -5px;
    right: -15px;
`;

export const IconButton = styled(ButtonIcon)`
    &&& {
        background: rgba(255, 255, 255, 0.1);
        transition: background-color 200ms ease;

        &:hover {
            background-color: rgba(255, 255, 255, 0.15);
        }
    }
`;
